/**
 *
 * WaitingForApprovalPage
 *
 */

import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Card, H2 } from '@pearsontechnology/aero-components';
import { Wrapper, CardWrapper } from './styles';
import messages from './messages';

function WaitingForApprovalPage() {
  return (
    <Wrapper>
      <CardWrapper>
        <Card>
          <H2><FormattedMessage {...messages.title} /></H2>
        </Card>
      </CardWrapper>
    </Wrapper>
  );
}

export default WaitingForApprovalPage;
